import { styled } from '@mui/material'

export const Container = styled('div')`
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
